import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

export const GAHTBloodResults_ID = 'imago.gaht.blood-results' as EMRTypeID & EMRKindID
